
import Home from "./index";
export default class HomeView extends Home {}
